import axios from "axios";

export default {
  async create(formData) {
    const files = new FormData();
    for (let i=0; i<formData.files.length; i+=1) {
      files.append("files", formData.files[i]);
    }

    const data = formData;
    data.files = undefined;
    files.append("email", JSON.stringify(data));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(`/emails/rent-object-bookings/${formData.rentObjectBookingId}`, files, config);
  },
  async resend(formData) {
    return axios.post('/emails', formData);
  },
  async sendSimple(formData) {
    return axios.post('/emails/simple', formData);
  },
  async findAll(formData) {
    return axios.get(`/emails/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async getAttachement(formData) {
    return axios.get(`/email-attachements/${formData.id}`, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/emails/${id}`);
  },
};